import { render, staticRenderFns } from "./live.vue?vue&type=template&id=afe93672&scoped=true&"
import script from "./live.vue?vue&type=script&lang=ts&"
export * from "./live.vue?vue&type=script&lang=ts&"
import style0 from "./live.vue?vue&type=style&index=0&id=afe93672&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe93672",
  null
  
)

export default component.exports